import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventListGetResponse, Event, EventListQuery } from '../../../shared/interfaces/event.interfaces';

const basePath = '/event';

@Injectable({
  providedIn: 'root',
})

export class EventService {
  constructor(private http: HttpClient) { }

  getAllEvents(EventListQuery: EventListQuery): Observable<EventListGetResponse> {
    const params = new HttpParams()
      .set('start_event_id', EventListQuery?.start_event_id ?? 0)
      .set('start_date', EventListQuery?.start_date ?? '')
      .set('end_date', EventListQuery?.end_date ?? '')
      .set('visibles', EventListQuery?.visibles ?? false)
      .set('rows', EventListQuery?.rows ?? 50)
      .set('first', EventListQuery?.first ?? 0)
      .set('sort_order', EventListQuery?.sort_order ?? 1)
      .set('sort_field', EventListQuery?.sort_field ?? 'id')
      .set('filters', JSON.stringify(EventListQuery?.filters ?? {}))
    return this.http.get<EventListGetResponse>(`${basePath}`, { params });
  }

  getEventById(id: number): Observable<Event> {
    return this.http.get<Event>(`${basePath}/${id}`);
  }

}
